import * as React from 'react'
import classNames from 'classnames'
import style from './swiper-button.module.scss'

interface IProps {
  type?: 'prev' | 'next'
  className?: string
  clkTeaParams?: string
  buttonStyle?: React.CSSProperties
  onClick?: () => void
  theme?: 'light' | 'gray'
}
const SwiperButton = React.forwardRef<HTMLInputElement, IProps>(
  (
    {
      type = 'prev',
      className = '',
      buttonStyle = {},
      onClick,
      clkTeaParams,
      theme = 'light',
    },
    ref
  ) => {
    return (
      <React.Fragment>
        <span
          ref={ref}
          onClick={onClick}
          className={classNames(
            style['button-wrapper'],
            'button-wrapper',
            className,
            type
          )}
          style={buttonStyle}
          data-log-click={clkTeaParams}
        >
          <button
            type={'button'}
            className={`${style['swiper-button']} swiper-button ${theme}`}
          >
            <i
              className={classNames('DCD_Icon', {
                icon_triangle_right: type === 'next',
                icon_triangle_left: type === 'prev',
              })}
            />
          </button>
        </span>
      </React.Fragment>
    )
  }
)

export default SwiperButton
